import { render, staticRenderFns } from "./TicketsDayco.vue?vue&type=template&id=74298439&"
import script from "./TicketsDayco.vue?vue&type=script&lang=ts&"
export * from "./TicketsDayco.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsDayco.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VPagination,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74298439')) {
      api.createRecord('74298439', component.options)
    } else {
      api.reload('74298439', component.options)
    }
    module.hot.accept("./TicketsDayco.vue?vue&type=template&id=74298439&", function () {
      api.rerender('74298439', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/TicketsDayco.vue"
export default component.exports